import { render, staticRenderFns } from "./TreatmentItem.vue?vue&type=template&id=23f84337&scoped=true"
import script from "./TreatmentItem.vue?vue&type=script&lang=ts"
export * from "./TreatmentItem.vue?vue&type=script&lang=ts"
import style0 from "./TreatmentItem.vue?vue&type=style&index=0&id=23f84337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f84337",
  null
  
)

export default component.exports